// current page styles
import '../../blocks_fss/page/page.less';
import './finders-service-selector.less';

// svg sprite icons
import '../../images-svg-sprite/chevron.svg';
import '../../images-svg-sprite/chevron2.svg';
import '../../images-svg-sprite/chevron_mob.svg';
import '../../images-svg-sprite/mobile-loop.svg';
import '../../images-svg-sprite/close_regular.svg';

import '../../images-svg-sprite/attention.svg';

import '../../images-svg-sprite/filter-white.svg';
import '../../images-svg-sprite/filter-black.svg';
import './service-analytics';

// current page specific code
import FinderSearch from '../../blocks_fss/js-srp-mediator/js-finder-mediator';

import { FAMILY_FILTERS_REQUEST } from '../../blocks_fss/constants/requestHandlingOptions';

// require scripts from page (main common file)
require('../../blocks_fss/page/page.js');

const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

function isIE() {
    const { userAgent } = window.navigator;
    const msie = userAgent.indexOf('MSIE ');
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
}

function isMobileViewActive() {
    return window.innerWidth < 960;
}

// eslint-disable-next-line consistent-return
$(document).ready(() => {
    /* js-srp-mediator call */
    const currentMediator = document.querySelector('.js-srp-mediator-outer');
    if (currentMediator) {
        new FinderSearch('tools').init(currentMediator);
    }

    /* insert param from url string to search fields */

    const string = document.querySelector('.js-searched-phrase').value;
    const searchInputsCollection = document.querySelectorAll('.js-global-search__field');

    if (searchInputsCollection.length > 0) {
        const searchInputsArray = [...searchInputsCollection];

        searchInputsArray.forEach(item => {
            item.value = string;
        });
    }

    handleNoResultsPreventFromScroll();

    function preventFromInputScrollActivate() {
        $('html').addClass('preventScrollOnInput');
        $('body').addClass('preventScrollOnInput');
    }

    function preventFromInputScrollDeactivate() {
        $('html').removeClass('preventScrollOnInput');
        $('body').removeClass('preventScrollOnInput');
    }

    $(window).on('fetchEnd', () => {
        handleModalInit();
        initializeFamilyBlock();
        initializeModelNumberBlock();
        if (!isMobileViewActive()) {
            focusOnModelInput();
            noResultsContainerInit();
        }

        $('.pagination-apc__show-more').on('click', () => {
            $('.trade-ups-banner').hide();
            $('.ups-selector-banner').hide();
        });

        handleNoResultsPreventFromScroll();

        noResultsClickInit();

        if (isIE()) {
            $('.ui-autocomplete').hide();
            $('.finders-no-results-found-wrapper').addClass('displayNone');
        }
    });

    // Product card Tags
    const TagsContainer = container => {
        const showMoreValue = container.dataset.localizeShowMore;
        const tags = container.querySelectorAll('.result-list__item-tag');
        const numberOfVisibleTags = 2;

        if (tags.length <= numberOfVisibleTags) return;

        // Create a container to wrap hidden tags
        const hiddenTagsContainer = document.createElement('div');
        hiddenTagsContainer.classList.add('collapsed-tags');

        // Append tags to 'hiddenTagsContainer' (starting from 2nd element)
        tags.forEach((element, index) => {
            if (index >= numberOfVisibleTags) hiddenTagsContainer.append(element);
        });

        // Create 'Show More' button
        const showMoreButton = document.createElement('div');
        showMoreButton.classList.add('show-more-tags-btn');
        const showMoreSpan = document.createElement('span');
        showMoreSpan.textContent = `+ ${tags.length - numberOfVisibleTags} ${showMoreValue}`;
        showMoreButton.append(showMoreSpan);

        // Append 'hiddenTagsContainer' and 'showMoreButton' to 'container'
        container.append(hiddenTagsContainer);
        container.append(showMoreButton);

        const handleShowMoreButtonClick = event => {
            hiddenTagsContainer.classList.add('collapsed-tags_open');
            event.target.parentNode.remove();
        };

        // Activate 'Show more' button
        showMoreButton.style.display = 'block';

        showMoreButton.addEventListener('click', handleShowMoreButtonClick);
    };

    if (!isMobileViewActive()) {
        focusOnModelInput();
        noResultsContainerInit();
    } else {
        const tagsContainers = document.querySelectorAll('.result-list__item-tag-wrapper');
        if (!tagsContainers.length) {
            return console.error(
                'Forgot to attach result-list__item-tag-wrapper to the Product Card',
            );
        }
        tagsContainers.forEach(container => new TagsContainer(container));
    }

    function focusOnModelInput() {
        if (isIE()) return;
        const $modelInput = $('.modelNumber-input');
        if (!$modelInput.val()) {
            $modelInput.focus();
        }
    }

    function noResultsContainerInit() {
        $('.finders-no-results-found-wrapper')
            .appendTo('.batteries-model-block-container')
            .first();
    }

    function handleDataAjaxParamSend(container) {
        const dataAjaxParam = $(container).data('ajax-param');
        if (!dataAjaxParam) return;

        const parentContainer =
            $(container)
                .closest('.js-filter-list__item')
                .get(0) || $('.js-filter-list__item').get(0);

        const event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: dataAjaxParam },
        });

        parentContainer.dispatchEvent(event);
    }

    noResultsClickInit();

    function noResultsClickInit() {
        $('.finders-no-results-found-wrapper-link').on('mousedown tap', function() {
            handleBodyScrollActivate();
            handleDataAjaxParamSend($(this));
        });
    }

    function showLoaderOnMobile() {
        if (isMobileViewActive()) {
            $('.model-loader').addClass('show');
        }
    }

    function hideLoaderOnMobile() {
        if (isMobileViewActive()) {
            $('.model-loader').removeClass('show');
        }
    }

    let currentRequest = null;
    let isRequestPending = false;
    let closeButtonClickedWhileResponsePending = false;

    function sendRequest(categoryDimVal, categoryPageNum, ntt, nttPageNum) {
        showLoaderOnMobile();

        isRequestPending = true;
        const url = $('#family-select').attr('data-ajax-source');
        const symbol = url.indexOf('?') >= 0 ? '&' : '?';

        const isScrolling = (categoryDimVal && categoryPageNum) || (ntt && nttPageNum);
        const isTyping = Boolean(ntt);
        let newUrl;

        if (categoryDimVal) {
            newUrl = `${url}${symbol}categoryDimVal=${categoryDimVal}`;
        }
        if (categoryDimVal && categoryPageNum) {
            newUrl = `${url}${symbol}categoryDimVal=${categoryDimVal}&pageNum=${categoryPageNum}`;
        }
        if (ntt) {
            newUrl = `${url}${symbol}Ntt=${ntt}*`;
        }
        if (ntt && nttPageNum) {
            newUrl = `${url}${symbol}Ntt=${ntt}*&pageNum=${nttPageNum}`;
        }

        currentRequest = jQuery.ajax({
            type: 'GET',
            url: newUrl,
            contentType: 'text/html',
            dataType: 'json',
            beforeSend() {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success(data) {
                isRequestPending = false;
                handleResponse(data, isScrolling, isTyping);
                hideLoaderOnMobile();
            },
            error(request, status, error) {
                console.log(error);
            },
        });
    }

    function filterResponseData(data) {
        return {
            label: data.displayName,
            partNumber: data.partNumber,
            url: data.href,
            src: data.image,
            nameTag: data.nameTag,
        };
    }

    let isResponseEmpty = false;
    let matchedModelHref;
    const ENTER_KEY = 13;

    function handleResponse(data, isScrolling, isTyping) {
        if (data[0] && data[0].nothingFoundLabel) {
            noResultsFoundWrapperMobileUpdate(data[0]);
            $('.modelNumber-input').autocomplete('option', 'source', []);
            if (closeButtonClickedWhileResponsePending) {
                hideModelInputOnMobile();
            } else {
                noResultsFoundWrapperMobileShow();
            }
            isResponseEmpty = true;
            closeButtonClickedWhileResponsePending = false;
            return;
        }
        noResultsFoundWrapperMobileHide();
        isResponseEmpty = false;

        matchedModelHref = data.hrefPressedByEnter;

        if (!isScrolling) {
            const newItems = data.items.map(filterResponseData);
            $('.modelNumber-input').autocomplete('option', 'source', newItems);

            if (isTyping && newItems.length) {
                if (isMobileViewActive()) {
                    if (closeButtonClickedWhileResponsePending) {
                        hideModelInputOnMobile();
                        $('.ui-autocomplete').css('display', 'none');
                    } else {
                        noResultsFoundWrapperMobileHide();
                        $('.modelNumber-input').autocomplete('search', '');
                    }
                    closeButtonClickedWhileResponsePending = false;
                    return;
                }
                handleModelShowAllbuttonActivate(isTyping);
                return;
            }
            if (isTyping) {
                noResultsFoundWrapperMobileShow();
                handleModelShowAllbuttonActivate();
            } else if (!isMobileViewActive()) {
                if (
                    $('.family-select')
                        .eq(0)
                        .find('option:selected')
                        .data('ajax-param')
                ) {
                    handleModelShowAllbuttonActivate();
                    noResultsFoundWrapperMobileHide();
                }
                if (
                    !$('.family-select')
                        .eq(0)
                        .find('option:selected')
                        .data('ajax-param') &&
                    window.location.href.indexOf('parentCategory') > 0
                ) {
                    handleModelShowAllbuttonActivate();
                }
            } else {
                if (
                    $('.family-select')
                        .eq(1)
                        .find('option:selected')
                        .data('ajax-param')
                ) {
                    $('.modelNumber-input').autocomplete('search', '');
                    noResultsFoundWrapperMobileHide();
                    return;
                }
                if (
                    !$('.family-select')
                        .eq(1)
                        .find('option:selected')
                        .data('ajax-param') &&
                    window.location.href.indexOf('parentCategory') > 0
                ) {
                    handleModelShowAllbuttonActivate();
                }
            }
        } else {
            const allItems = $('.modelNumber-input').autocomplete('option', 'source');
            const items = data.items.map(filterResponseData);
            const newCombinedItems = allItems.concat(items);
            $('.modelNumber-input').autocomplete('option', 'source', newCombinedItems);
            if (isMobileViewActive()) {
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                return;
            }
            handleModelShowAllbuttonActivate();
        }
    }

    /* Initialize 'Families' input */

    initializeFamilyBlock();

    function initializeFamilyBlock() {
        $('.family-select')
            .selectmenu({
                change: handleFamilyArrowRotate,
                open() {
                    getElementBasedOnViewportSize('.family-select')
                        .find('option:selected')
                        .addClass('ui-state-select');

                    $(this)
                        .closest('.filter-list__item')
                        .addClass('fixedMobilePosition');
                    handleFamilySelectorToggle();
                    if (isMobileViewActive()) {
                        handleBodyPreventFromScroll();
                    }
                    if ($('.backgroundOnBlur').length) {
                        $('.backgroundOnBlur').addClass('active');
                    }

                    $(
                        'div.ui-selectmenu-menu.ui-selectmenu-open li.ui-menu-item div.ui-menu-item-wrapper',
                    ).each(function(idx) {
                        const options = isMobileViewActive()
                            ? $('.filters-wrap-mob select option')
                            : $('.filters-wrap select option');

                        $(this).addClass(options.eq(idx).attr('class'));
                        $(this).attr('data-item-name', options.eq(idx).attr('data-item-name'));
                    });
                },
                close() {
                    $('.backgroundOnBlur').removeClass('active');
                    $(this)
                        .closest('.filter-list__item')
                        .removeClass('fixedMobilePosition');
                    handleFamilySelectorToggle();
                    if (isMobileViewActive()) {
                        handleBodyScrollActivate();
                    }
                },
                select: handleFamilySelect,
                create() {
                    if (isMobileViewActive()) {
                        closeFamilyMobileButtonInit();

                        $('body').on('tap', '.close-model-family-button', () => {
                            $('.family-select').selectmenu('close');
                        });

                        $('body').on('tap', '.backgroundOnBlur', e => {
                            $(document).off('mousedown');
                            e.stopPropagation();
                            return false;
                        });
                    }
                    if (isAllFamilyFirstOption()) {
                        handleModelExpandButtonHide();
                        // toggleModelPlaceholder();
                    }
                    toggleModelPlaceholder();
                },
            })
            .eq(0);
    }

    function getElementBasedOnViewportSize(element) {
        const activeView = isMobileViewActive() ? 1 : 0;
        return $(element).eq(activeView);
    }

    function isAllFamilyFirstOption() {
        return (
            getElementBasedOnViewportSize('.family-select')
                .find('option:selected')
                .data('ajaxParam')
                .indexOf('parentCategory') < 0
        );
    }

    function handleFamilySelectorToggle() {
        noResultsFoundWrapperMobileHide();
        toggleFamilyBlockAnimate();
        handleFamilyArrowRotate();
    }

    function handleNoResultsPreventFromScroll() {
        $('.finders-no-results-found-wrapper').on('touchmove', e => {
            e.preventDefault();
        });
    }

    function toggleModelPlaceholder() {
        const placeholder = isAllFamilyFirstOption()
            ? $('.modelNumber-input').data('model-placeholder-two')
            : $('.modelNumber-input').data('model-placeholder-one');
        $('.modelNumber-input').attr('placeholder', placeholder);
    }

    function removeProductCard() {
        $('.selectItem_description').remove();
        $('.filter-list__btn-select_product').remove();
    }

    function removeSelectedProduct() {
        removeProductCard();

        $('.modelNumber-input-showAll').show();
        $('.modelNumber-input.ui-autocomplete-input').show();
        $('.batteries-model-block-modelNumber .control-buttons').show();

        selectedProduct = null;
    }

    /* 'Expand button' for 'Families' input rotate */
    function handleFamilySelect() {
        $(document).on('mousedown');
        isResponseEmpty = false;
        if (isAllFamilyFirstOption()) {
            handleModelExpandButtonHide();
        } else {
            handleModelExpandButtonShow();
        }
        toggleModelPlaceholder();
        clearModelInput();
        handleModelClearButtonHide();
        handleFamilyArrowRotate();

        $('.ui-state-select').removeClass('ui-state-select');

        $('.ui-autocomplete').scrollTop(0);

        if (
            $(this)
                .find('option:selected')
                .data('ajax-param')
        ) {
            const request = getElementBasedOnViewportSize('.family-select')
                .find('option:selected')
                .data('ajax-param');
            if (!request) return;

            const container = $('.js-filter-list__item').get(0);

            container.dispatchEvent(
                new CustomEvent('ajax-src-container-click', {
                    bubbles: true,
                    detail: {
                        ajaxParam: request,
                        option: FAMILY_FILTERS_REQUEST,
                    },
                }),
            );
        } else {
            const selectedOption = $(this)
                .find('option:selected')
                .attr('id');
            sendRequest(selectedOption);
        }
    }

    function handleFamilyArrowRotate() {
        $('.ui-selectmenu-icon').toggleClass('rotate');
    }

    function handleBodyPreventFromScroll() {
        $('html, body').addClass('noScroll');
    }

    function handleBodyScrollActivate() {
        $('html, body').removeClass('noScroll');
    }

    /* 'Close' button for 'Families' input (on Mobile) */
    function closeFamilyMobileButtonInit() {
        $('.ui-selectmenu-menu')
            .last()
            .prepend('<div class="close-model-family-button">Close</div>');
    }

    function toggleFamilyBlockAnimate() {
        if (!isMobileViewActive()) return;

        if (
            $('.ui-selectmenu-button')
                .eq(1)
                .attr('aria-expanded') === 'true'
        ) {
            $('.ui-selectmenu-menu')
                .css('bottom', '-300px')
                .animate({ bottom: '0' }, 'fast');
        } else {
            $('.ui-selectmenu-menu')
                .css('display', 'block')
                .animate({ bottom: '-300px' }, 'fast');
        }
    }

    /* Initialize 'Models' input */
    const items = 50;
    const modelClass = items < 12 ? 'mobile-activated-sm' : 'mobile-activated-lg';

    const itemList = [];

    $('body').append('<span class="hightlight"></span>');

    if (isMobileViewActive()) {
        $('body').prepend('<div class="backgroundOnBlur"></div>');
    }

    let i = 1;
    let breakpoint = 310;
    let previousState = [];
    let isShowAllItemsButtonClicked = false;
    let isTapHoldActive = false;
    let isModelListActive = false;

    function handleModelItmSelect(dataAjaxParam) {
        if (!dataAjaxParam) return;
        const container = $('.js-filter-list__item').get(0);

        const event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: dataAjaxParam },
        });

        container.dispatchEvent(event);
        if (isMobileViewActive()) {
            hideModelInputOnMobile();
        }
    }

    initializeModelNumberBlock();
    let isModelOpen = false;
    let selectedProduct;

    function heightlighterText(text, term) {
        return String(text).replace(
            new RegExp(term, 'gi'),
            '<span class="model-heightlighter__thin">$&</span>',
        );
    }

    function initializeModelNumberBlock() {
        isShowAllItemsButtonClicked = false;
        $('.modelNumber-input').autocomplete({
            source: itemList,
            minLength: 0,
            delay: 0,
            clearButton: true,
            select(event, ui) {
                if (isMobileViewActive()) {
                    isResponseEmpty = false;
                }
                if (event.keyCode === 13) {
                    handleModelItmSelect(ui.item.url);
                }
                if (isIE()) {
                    $('.modelNumber-input-hideAll').addClass('hidden');
                    $('.ui-autocomplete').hide();
                }

                hideModelInputOnMobile();
            },
            open() {
                isModelOpen = true;
                if (isMobileViewActive()) {
                    $('.ui-menu-item').off('hover mouseover mouseenter mouseup');
                }
                $('.modelNumber-input-showAll').addClass('hidden');
                $('.modelNumber-input-hideAll').removeClass('hidden');

                if ($('.ui-autocomplete .ui-menu-item').length <= 31) {
                    $('.ui-autocomplete').scrollTop(0);
                }
                if (isAllFamilyFirstOption()) {
                    $('.modelNumber-input-hideAll').hide();
                }

                if (!isIE()) {
                    this.focus();
                }
            },
            create(event) {
                /* eslint-disable indent */
                selectedProduct = this.getAttribute('data-part-number')
                    ? {
                          label: this.getAttribute('data-display-name'),
                          partNumber: this.getAttribute('data-part-number'),
                          src: this.getAttribute('data-image-url'),
                      }
                    : null;
                /* eslint-enable */
                if (!isMobileViewActive()) {
                    const $uiAutocomplete = $('.ui-autocomplete');

                    $uiAutocomplete.off('click.modelNumberBlockNamespace'); // to prevent redundant handler
                    $uiAutocomplete.on(
                        'click.modelNumberBlockNamespace',
                        '.ui-menu-item',
                        function() {
                            const dataAjaxParam = $(this).attr('data-ajax-param');
                            handleModelItmSelect(dataAjaxParam);
                        },
                    );
                } else if (iOS) {
                    $('.ui-autocomplete').on('tap', '.ui-menu-item', function() {
                        const dataAjaxParam = $(this).attr('data-ajax-param');
                        handleModelItmSelect(dataAjaxParam);
                    });

                    $('.ui-autocomplete').on('taphold', '.ui-menu-item', () => {
                        isTapHoldActive = true;
                    });
                } else {
                    $('.ui-autocomplete').on('tap', '.ui-menu-item', function() {
                        const dataAjaxParam = $(this).attr('data-ajax-param');
                        handleModelItmSelect(dataAjaxParam);
                    });

                    $('.ui-autocomplete').on('taphold', '.ui-menu-item', () => {
                        $('.modelNumber-input').off('blur');
                        $('.ui-autocomplete').css('display', 'block');
                        isTapHoldActive = true;
                    });
                }

                if ($('.modelNumber-input').val().length) {
                    handleModelClearButtonShow();
                }

                $('.ui-autocomplete').scroll(function() {
                    if (!isMobileViewActive()) {
                        const scrollTop = $(this).scrollTop();
                        if (event.target.value) {
                            if (scrollTop >= breakpoint) {
                                breakpoint += 300;
                                // eslint-disable-next-line no-plusplus
                                i++;
                                sendRequest(false, false, event.target.value, i);
                            }
                        } else if (scrollTop >= breakpoint) {
                            breakpoint += 300;
                            // eslint-disable-next-line no-plusplus
                            i++;
                            const selectedOption = $('.family-select')
                                .eq(0)
                                .find('option:selected')
                                .attr('id');
                            sendRequest(selectedOption, i);
                        }
                    } else if (event.target.value) {
                        if (
                            $(this).scrollTop() + $(this).innerHeight() >=
                            $(this)[0].scrollHeight
                        ) {
                            sendRequest(false, false, event.target.value, i);
                        }
                    } else if (
                        $(this).scrollTop() + $(this).innerHeight() >=
                        $(this)[0].scrollHeight
                    ) {
                        const selectedOption = $('.family-select')
                            .eq(1)
                            .find('option:selected')
                            .attr('id');
                        sendRequest(selectedOption, i);
                    }
                });

                toggleModalBlockHightlight();

                // eslint-disable-next-line no-underscore-dangle
                $(this).data('ui-autocomplete')._renderItem = function(ul, item) {
                    const title = heightlighterText(item.label, this.term);
                    const label = heightlighterText(item.partNumber, this.term);

                    const isSelect =
                        selectedProduct && selectedProduct.partNumber === item.partNumber;

                    const productCard = `
                        <div class='listItem_description ${isSelect ? 'ui-state-select' : ''}'>
                            <div class='listItem_imageWrapper'>
                                <img class='listItem_image' src='${item.src}'/>
                            </div>
                            <div class='listItem_contentWrapper'>
                                <div class='listItem_title model-heightlighter'>${title}</div>
                                <div class='listItem_label model-heightlighter'>${label}</div>
                            </div>
                        </div>`;

                    return $('<li></li>')
                        .attr({
                            'data-ajax-param': item.url,
                            'data-item-name': item.nameTag,
                            'data-part-number': item.partNumber,
                        })
                        .data('item.autocomplete', item)
                        .append(productCard)
                        .appendTo(ul);
                };
                $('.control-buttons').css('display', 'flex');

                if (selectedProduct) {
                    renderProductCard(selectedProduct);
                }
            },
            response(event) {
                if ($('.modelNumber-input').val() === '') {
                    noResultsFoundWrapperMobileHide();
                }
                handleModelClearButtonToggle(event);
            },
            focus(event) {
                event.preventDefault();
                isModelListActive = true;
            },
            close() {
                isModelOpen = false;
                if (isMobileViewActive()) {
                    if (
                        $('.modelNumber-input')
                            .last()
                            .val().length
                    ) {
                        handleModelClearButtonShow();
                    }
                    if (isTapHoldActive) {
                        $('.modelNumber-input')
                            .last()
                            .autocomplete('search', '');
                        $('.ui-autocomplete').css('display', 'block');
                    }
                    isTapHoldActive = false;
                    noResultsFoundWrapperMobileHide();
                }
                $('.modelNumber-input-showAll').removeClass('hidden');
                $('.modelNumber-input-hideAll').addClass('hidden');
                breakpoint = 310;
                i = 1;
            },
        });

        if (isMobileViewActive()) {
            $('.batteries-model-block-modelNumber').append(
                '<div class="close-modelNumber-button hidden">Close</div>',
            );
        }

        $('.close-modelNumber-button').mousedown(() => {
            if (isRequestPending) {
                closeButtonClickedWhileResponsePending = true;
            }
            if (iOS) {
                preventFromInputScrollDeactivate();
            }

            if (selectedProduct) {
                renderProductCard(selectedProduct);
            }

            hideModelInputOnMobile();
            hideLoaderOnMobile();
        });

        /* 'Expand button' for 'Models' input */
        // eslint-disable-next-line consistent-return
        $('.modelNumber-input-showAll').click(() => {
            if (!isMobileViewActive()) {
                if (
                    $('.finders-no-results-found-wrapper').hasClass('displayNone') &&
                    !$('.modelNumber-input').autocomplete('option', 'source').length
                ) {
                    noResultsFoundWrapperMobileHide();
                }

                if (!isIE()) {
                    $('.modelNumber-input').focus();
                }

                $('.ui-autocomplete').css('display', 'none');
                if (
                    isResponseEmpty &&
                    $('.modelNumber-input')
                        .first()
                        .val().length
                ) {
                    noResultsFoundWrapperMobileShow();
                }
            } else {
                $('.ui-autocomplete').css('display', 'none');
                if (
                    isResponseEmpty &&
                    $('.modelNumber-input')
                        .last()
                        .val().length
                ) {
                    return handleNoResultsBlockShow();
                }
                if (isAllFamilyFirstOption()) {
                    return handleBlankBlockShow();
                }
            }
            isShowAllItemsButtonClicked = true;
            handleModelShowAllbuttonActivate();

            if (isMobileViewActive()) {
                showModelInputOnMobile();
                handleBodyPreventFromScroll();
            }
        });

        function renderProductCard(product) {
            removeProductCard();

            const { label, partNumber, src } = product;
            const selectedProductTitle = `<div class='filter-list__btn-select_product'>${label} &mdash; ${partNumber}</div>`;

            const selectedProductCard = `
                <div class='selectItem_description'>
                    <div class='selectItem_imageWrapper'>
                        <img class='selectItem_image' src='${src}'/>
                    </div>
                    <div class='selectItem_contentWrapper'>
                        <div class='selectItem_title'>
                            ${label}
                        </div>
                        <div class='selectItem_label'>
                            ${partNumber}
                        </div>
                    </div>
                    <span class='modelNumber-input-clear'></span>
                </div>`;

            $('.filters-wrap .filter-list__btn-title')
                .first()
                .after(selectedProductTitle);
            $('.filters-wrap-mob .filter-list__btn-title')
                .first()
                .after(selectedProductTitle);
            $('.batteries-model-block-modelNumber').prepend(selectedProductCard);

            $('.modelNumber-input.ui-autocomplete-input').hide();
            $('.batteries-model-block-modelNumber .control-buttons').hide();
        }

        $('.batteries-model-block-modelNumber').on(
            'click',
            '.selectItem_description',
            ({ target }) => {
                if (target.classList.contains('modelNumber-input-clear')) {
                    $('.modelNumber-input-clear').trigger('mousedown');
                } else {
                    const modelNumber = $('.modelNumber-input');

                    $('.selectItem_description').remove();
                    $('.modelNumber-input.ui-autocomplete-input').show();
                    $('.batteries-model-block-modelNumber .control-buttons').show();
                    modelNumber.last().autocomplete('search', '');
                    $('.modelNumber-input-showAll').trigger('click');
                    modelNumber.focus();
                }
            },
        );

        function handleNoResultsBlockShow() {
            showModelInputOnMobile();
            showModelCloseButtonOnMobile();
            noResultsFoundWrapperMobileShow();
        }

        function handleBlankBlockShow() {
            $('.modelNumber-input').autocomplete('option', 'source', []);
            $('.ui-autocomplete')
                .last()
                .show();
            showModelInputOnMobile();
            handleBodyPreventFromScroll();
        }

        $('.modelNumber-input-clear').mousedown(() => {
            if (!isMobileViewActive()) {
                handleModelClearButtonHide();
                hideModelInputOnMobile();
            }

            if (selectedProduct) {
                removeSelectedProduct();
            }

            if (!$('.batteries-model-block-modelNumber').hasClass(modelClass)) {
                if (isMobileViewActive()) {
                    clearModelInput();
                    return;
                }
                handleModelClearButtonHide();
                clearModelInput();
                $('.ui-autocomplete').empty();
                if (isAllFamilyFirstOption()) {
                    $('.ui-autocomplete')
                        .last()
                        .show();
                } else {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    $('.modelNumber-input-showAll').trigger('click');
                }
                return;
            }
            clearModelInput();
            if (isMobileViewActive()) {
                const selectedOption = $('.family-select')
                    .last()
                    .find('option:selected')
                    .attr('id');
                sendRequest(selectedOption);
            }

            if (isAllFamilyFirstOption()) {
                $('.ui-autocomplete').empty();
                $('.ui-autocomplete')
                    .last()
                    .show();
            }

            $('.modelNumber-input').focus();
            noResultsFoundWrapperMobileHide();
        });

        /* 'Focus on '.modelNumber-input' on Mobile */
        const deviceClickEvent = iOS ? 'tap' : 'click';

        $('.modelNumber-input').on(deviceClickEvent, () => {
            if (iOS) {
                preventFromInputScrollActivate();
            }
            if (isMobileViewActive()) {
                handleBodyPreventFromScroll();
                $('.modelNumber-input-showAll').trigger('click');
            }
        });

        let modelInputTimer = null;

        $('.modelNumber-input').on('input', function(event) {
            const self = $(this);
            clearTimeout(modelInputTimer);
            modelInputTimer = setTimeout(handleModalInputFieldUpdate.bind(this, event, self), 300);
        });

        function clearAndHideModelNumber() {
            $('.modelNumber-input').autocomplete('option', 'source', []);
            $('.ui-autocomplete').empty();
            $('.ui-autocomplete').hide();
        }

        function handleModalInputFieldUpdate(event, self) {
            if (isMobileViewActive()) {
                if (isResponseEmpty) {
                    $('.ui-autocomplete').empty();
                }
            }

            if (!self.val().length) {
                if (!isAllFamilyFirstOption()) {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    const $showAllButton = $('.modelNumber-input-showAll');
                    const $hideAllButton = $('.modelNumber-input-hideAll');
                    if (isIE()) {
                        clearAndHideModelNumber();
                        $showAllButton.removeClass('hidden');
                        $hideAllButton.addClass('hidden');
                    } else {
                        sendRequest(selectedOption);
                        $showAllButton.trigger('mousedown');
                    }
                    return;
                }
                if (isMobileViewActive()) {
                    $('.modelNumber-input').autocomplete('option', 'source', []);
                    $('.ui-autocomplete').empty();
                    $('.ui-autocomplete')
                        .last()
                        .show();
                } else {
                    $('.modelNumber-input').autocomplete('option', 'source', []);
                    $('.ui-autocomplete').empty();
                    $('.ui-autocomplete').show();
                }
                return;
            }

            if (previousState.length) {
                const searchedValue = event.target.value;
                sendRequest(false, false, searchedValue);
                if (event.target.value === '') {
                    noResultsFoundWrapperMobileHide();
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                }
                return;
            }
            previousState = $('.modelNumber-input').autocomplete('option', 'source');
            $('.modelNumber-input').autocomplete({ source: [] });
            const searchedValue = event.target.value;
            sendRequest(false, false, searchedValue);
            if (event.target.value === '') {
                noResultsFoundWrapperMobileHide();
            }
        }

        $('.modelNumber-input').on('blur', () => {
            if (selectedProduct && !isModelOpen) {
                renderProductCard(selectedProduct);
            }

            if (!isMobileViewActive()) {
                noResultsFoundWrapperMobileHide();
            } else if (iOS) {
                preventFromInputScrollDeactivate();
            }
        });

        $('.modelNumber-input').on('keydown', event => {
            if (!(event.keyCode === ENTER_KEY)) {
                return;
            }
            if (isResponseEmpty) {
                const link = document.querySelector('.finders-no-results-found-wrapper-link');
                if (isMobileViewActive()) {
                    preventFromInputScrollDeactivate();
                    handleBodyScrollActivate();
                    $('.ui-autocomplete').hide();
                }
                handleDataAjaxParamSend(link);
                return;
            }
            if (!matchedModelHref || isModelListActive) {
                event.preventDefault();
                event.stopImmediatePropagation();
                isModelListActive = false;
                return;
            }
            handleModelItmSelect(matchedModelHref);
            $('.ui-autocomplete').hide();
            matchedModelHref = '';
        });
    }

    function handleModelShowAllbuttonActivate(isTyping) {
        if (!isMobileViewActive()) {
            if (isShowAllItemsButtonClicked) {
                if (
                    $('.modelNumber-input')
                        .first()
                        .val() &&
                    $('.modelNumber-input').autocomplete('option', 'source').length === 0
                ) {
                    const searchedValue = $('.modelNumber-input')
                        .first()
                        .val();
                    if (searchedValue.indexOf(' ')) {
                        const partNumber = searchedValue.substr(0, searchedValue.indexOf(' '));
                        sendRequest(false, false, partNumber);
                        return;
                    }

                    sendRequest(false, false, searchedValue);
                    return;
                }

                if (
                    !$('.modelNumber-input')
                        .first()
                        .val() &&
                    $('.modelNumber-input').autocomplete('option', 'source').length === 0
                ) {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    return;
                }

                if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                    if (window.location.href.indexOf('parentCategory') > 0) {
                        $('.modelNumber-input')
                            .first()
                            .autocomplete('search', '');
                        return;
                    }
                } else if (window.location.href.indexOf('parentCategory') > 0) {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    return;
                }
                // if we click showAll right again (wihout making any search) or for the first time
                if (
                    !previousState.length &&
                    $('.modelNumber-input').autocomplete('option', 'source').length
                ) {
                    $('.modelNumber-input')
                        .first()
                        .autocomplete('search', '');
                    isShowAllItemsButtonClicked = false;
                    return;
                }
                if (previousState.length) {
                    $('.modelNumber-input').autocomplete('option', 'source', previousState);
                    previousState = [];
                    $('.modelNumber-input')
                        .first()
                        .autocomplete('search', '');
                } else {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    $('.modelNumber-input')
                        .first()
                        .autocomplete('search', '');
                }
                isShowAllItemsButtonClicked = false;
            } else {
                // when nothing is found (prevState is valid)
                if ($('.modelNumber-input').autocomplete('option', 'source').length === 0) {
                    $('.modelNumber-input')
                        .first()
                        .autocomplete('search', '');
                    return;
                }

                if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                    if (window.location.href.indexOf('parentCategory') > 0 && isTyping) {
                        $('.modelNumber-input')
                            .first()
                            .autocomplete('search', '');
                        return;
                    }
                    if (window.location.href.indexOf('parentCategory') > 0) {
                        // $('.modelNumber-input').first().autocomplete('search', '');
                        return;
                    }
                } else if (window.location.href.indexOf('parentCategory') > 0) {
                    const selectedOption = $('.family-select')
                        .first()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    return;
                }

                // when we have found somethign (prevSate is valid)
                if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                    $('.modelNumber-input')
                        .first()
                        .autocomplete('search', '');
                }
            }
        } else if (isShowAllItemsButtonClicked) {
            if (
                $('.modelNumber-input')
                    .last()
                    .val() &&
                $('.modelNumber-input').autocomplete('option', 'source').length === 0
            ) {
                const searchedValue = $('.modelNumber-input')
                    .last()
                    .val();
                if (searchedValue.indexOf(' ')) {
                    const partNumber = searchedValue.substr(0, searchedValue.indexOf(' '));
                    sendRequest(false, false, partNumber);
                    return;
                }

                sendRequest(false, false, searchedValue);
                return;
            }
            if (
                !$('.modelNumber-input')
                    .last()
                    .val() &&
                $('.modelNumber-input').autocomplete('option', 'source').length === 0
            ) {
                const selectedOption = $('.family-select')
                    .last()
                    .find('option:selected')
                    .attr('id');
                sendRequest(selectedOption);
                return;
            }

            if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                if (
                    $('.modelNumber-input')
                        .last()
                        .val()
                ) {
                    if (window.location.href.indexOf('parentCategory') > 0) {
                        $('.modelNumber-input')
                            .last()
                            .autocomplete('search', '');
                        return;
                    }
                } else {
                    const selectedOption = $('.family-select')
                        .last()
                        .find('option:selected')
                        .attr('id');
                    sendRequest(selectedOption);
                    return;
                }
            } else if (window.location.href.indexOf('parentCategory') > 0) {
                const selectedOption = $('.family-select')
                    .last()
                    .find('option:selected')
                    .attr('id');
                sendRequest(selectedOption);
                return;
            }
            // if we click showAll right again (wihout making any search) or for the first time
            if (
                !previousState.length &&
                $('.modelNumber-input').autocomplete('option', 'source').length
            ) {
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                showModelInputOnMobile();
                isShowAllItemsButtonClicked = false;
                return;
            }
            if (previousState.length) {
                $('.modelNumber-input').autocomplete('option', 'source', previousState);
                previousState = [];
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                showModelInputOnMobile();
            } else {
                const selectedOption = $('.family-select')
                    .last()
                    .find('option:selected')
                    .attr('id');
                sendRequest(selectedOption);
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                showModelInputOnMobile();
            }
            isShowAllItemsButtonClicked = false;
        } else {
            // when nothing is found (prevState is valid)
            if ($('.modelNumber-input').autocomplete('option', 'source').length === 0) {
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                showModelInputOnMobile();
                return;
            }

            if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                if (window.location.href.indexOf('parentCategory') > 0 && isTyping) {
                    $('.modelNumber-input')
                        .last()
                        .autocomplete('search', '');
                    return;
                }
                if (window.location.href.indexOf('parentCategory') > 0) {
                    // $('.modelNumber-input').first().autocomplete('search', '');
                    return;
                }
            } else if (window.location.href.indexOf('parentCategory') > 0) {
                const selectedOption = $('.family-select')
                    .last()
                    .find('option:selected')
                    .attr('id');
                sendRequest(selectedOption);
                return;
            }

            // when we have found somethign (prevSate is valid)
            if ($('.modelNumber-input').autocomplete('option', 'source').length) {
                $('.modelNumber-input')
                    .last()
                    .autocomplete('search', '');
                showModelInputOnMobile();
            }
        }
    }

    function toggleModalBlockHightlight() {
        if ($('.modelNumber-input').hasClass('active')) {
            $('.modelNumber-input').removeClass('active');
        } else {
            $('.modelNumber-input').addClass('active');
        }
    }

    function handleModelExpandButtonShow() {
        $('.modelNumber-input-showAll').show();
        toggleModalBlockHightlight();
    }

    function handleModelExpandButtonHide() {
        $('.modelNumber-input-showAll').hide();
        toggleModalBlockHightlight();
    }

    /* 'Romove' button for 'Models' input */

    function handleModelClearButtonToggle(e) {
        if (e.target.value.length > 0) {
            handleModelClearButtonShow();
        } else {
            handleModelClearButtonHide();
        }
    }

    function handleModelClearButtonHide() {
        $('.modelNumber-input-clear').hide();
    }

    function handleModelClearButtonShow() {
        $('.modelNumber-input-clear').show();
    }

    function clearModelInput() {
        $('.modelNumber-input').val('');
    }

    function noResultsFoundWrapperMobileShow() {
        $('.finders-no-results-found-wrapper').removeClass('displayNone');
        if (isMobileViewActive()) {
            handleBodyPreventFromScroll();
        }
    }

    function noResultsFoundWrapperMobileHide() {
        $('.finders-no-results-found-wrapper').addClass('displayNone');
        if (!isMobileViewActive()) {
            $('.modelNumber-input-showAll').removeClass('hidden');
            $('.modelNumber-input-hideAll').addClass('hidden');
        } else {
            handleBodyScrollActivate();
        }
    }

    function noResultsFoundWrapperMobileUpdate({
        nothingFoundLabel,
        seeOurSuggestionsLabel,
        href,
    }) {
        $('.finders-no-results-found-wrapper-text').text(nothingFoundLabel);
        $('.finders-no-results-found-wrapper-link').text(seeOurSuggestionsLabel);
        $('.finders-no-results-found-wrapper-link').data('ajax-param', href);
    }

    function hideModelInputOnMobile() {
        if (isMobileViewActive()) {
            noResultsFoundWrapperMobileHide();
            $('.ui-autocomplete').removeClass(modelClass);
            hideModelListOnMobile();
            hideModelCloseButtonOnMobile();
            $('.batteries-model-block-modelNumber').removeClass(modelClass);
            handleBodyScrollActivate();
        }
    }

    function showModelInputOnMobile() {
        $('.batteries-model-block-modelNumber').addClass(modelClass);
        $('.ui-autocomplete').addClass(modelClass);
        if (!$('.modelNumber-input').autocomplete('option', 'source')) {
            showModelListOnMobile();
        }

        showModelCloseButtonOnMobile();
    }

    function hideModelCloseButtonOnMobile() {
        $('.close-modelNumber-button').addClass('hidden');
    }

    function showModelCloseButtonOnMobile() {
        $('.close-modelNumber-button').removeClass('hidden');
    }

    function hideModelListOnMobile() {
        $('.ui-autocomplete').css('display', 'none');
    }

    function showModelListOnMobile() {
        $('.ui-autocomplete').css('display', 'block');
    }

    /* Initialize modal component */

    handleModalInit();

    let modelModal;
    let reasonsModal;
    function handleModalInit() {
        modelModal = $('#unknown-model');
        reasonsModal = $('#five-reasons-popup');
        $('.batteries-model-block-help-text-js').on('click', () => handleModalOpen(modelModal));
        $('.five-reasons-block--link').on('click', () => {
            handleModalOpen(reasonsModal);
            if (isMobileViewActive()) {
                handleBodyPreventFromScroll();
            }
        });
        $('.unknown-model-button-js, .unknown-model-close-js').on('click', () =>
            handleModalClose(modelModal),
        );
        $('.five-reasons-popup--close-js').on('click', () => {
            handleModalClose(reasonsModal);
            if (isMobileViewActive()) {
                handleBodyScrollActivate();
            }
        });
        $('#five-reasons-popup, #unknown-model').on('click', e => {
            if (e.target.id) {
                handleModalClose(e.target);
            }
        });
        $(document).on('keyup', e => {
            if (e.keyCode === 27 || e.which === 27) {
                handleModalClose($.find('.modal__visible'));
            }
        });
    }

    function handleModalOpen(target) {
        $(target).addClass('modal__visible');
    }

    function handleModalClose(target) {
        $(target).removeClass('modal__visible');
    }
});
